import { Info } from "lucide-react";

import { ArtistEditsInfo } from "@design-lab/features/design-artwork/ui/ArtistEditsInfo";
import { PrintPerfectExplanatoryTooltip } from "@design-lab/features/design-artwork/ui/quality-tabs/PrintPerfectExplanatoryTooltip";
import { useResponsive } from "@design-lab/shared/hooks/useResponsive";

export function PinningHeader() {
  const { isDesktop } = useResponsive();

  return (
    <div
      className={`flex w-full shrink-0 flex-col bg-white p-4 ${isDesktop ? "" : "shadow-sm"}`}
      data-testid="pinning-header"
    >
      <div className="flex items-center justify-between">
        <h2 className="m-0 text-lg font-semibold text-gray-800">Get Free AI Edits</h2>
        <div className="flex items-center gap-1">
          <Info className="size-4 text-gray-500" aria-hidden="true" />
          <PrintPerfectExplanatoryTooltip
            label="How it works"
            centeredMobile
            buttonClassName="pl-0"
          >
            <ArtistEditsInfo />
          </PrintPerfectExplanatoryTooltip>
        </div>
      </div>
    </div>
  );
}
